import InformationBanner from './InformationBanner';

export default InformationBanner;
